(function() {
  'use strict';

  var TurfCore = window.ATUTurfOrdering;
  if (!TurfCore) {
    if (window.ATUTurfConfiguratorWaitingForCore) return;
    window.ATUTurfConfiguratorWaitingForCore = true;

    var currentScript = document.currentScript;
    var configuratorSrc = currentScript && currentScript.src ? currentScript.src : '';
    var coreSrc = configuratorSrc ? configuratorSrc.replace(/turf-configurator\.js(?:\?[^#]*)?/, 'turf-ordering-core.js') : '';

    if (!coreSrc || coreSrc === configuratorSrc) return;

    var coreScript = document.createElement('script');
    coreScript.src = coreSrc;
    coreScript.async = false;
    coreScript.onload = function() {
      window.ATUTurfConfiguratorWaitingForCore = false;

      if (!window.ATUTurfOrdering) return;

      var retryScript = document.createElement('script');
      retryScript.src = configuratorSrc + (configuratorSrc.indexOf('?') === -1 ? '?' : '&') + 'core_ready=1';
      retryScript.async = false;
      document.head.appendChild(retryScript);
    };
    coreScript.onerror = function() {
      window.ATUTurfConfiguratorWaitingForCore = false;
    };

    document.head.appendChild(coreScript);
    return;
  }

  var MONEY_FALLBACK = '${{amount}}';

  function numberValue(value) {
    var number = parseFloat(value);
    return Number.isFinite(number) ? number : 0;
  }

  function integerValue(value) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : 0;
  }

  function plural(count, singular, pluralText) {
    return count + ' ' + (count === 1 ? singular : pluralText);
  }

  function parseRollLength(value, rollWidth) {
    return TurfCore.parseRollLength(value, {
      rollWidthFt: rollWidth
    });
  }

  function money(cents) {
    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      return window.Currency.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : MONEY_FALLBACK);
    }

    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function cartAddUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : null;
    if (!root && window.routes && window.routes.rootUrl) root = window.routes.rootUrl;
    root = root || '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function cartUrl() {
    return window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
  }

  function variantTitle(variant) {
    if (!variant) return '-';
    return variant.title && variant.title !== 'Default Title' ? variant.title : 'Default';
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function(character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function requestedDimensions(state) {
    if (state.mode === 'dimensions') {
      return state.length + ' ft x ' + state.width + ' ft';
    }

    return state.projectSqft + ' sq ft';
  }

  function rollSummary(state, rollWidth) {
    if (!state || !state.resolvedCuts || !state.resolvedCuts.length) return '-';

    var sizes = state.resolvedCuts.map(function(cut) {
      return rollWidth + ' ft x ' + cut.actualLength + ' ft';
    });
    var uniqueSizes = sizes.filter(function(size, index) {
      return sizes.indexOf(size) === index;
    });

    return uniqueSizes.length === 1 ? uniqueSizes[0] : uniqueSizes.join(' + ');
  }

  function missingVariantMessage(cut, rollWidth) {
    var length = cut && cut.requestedLength ? cut.requestedLength : '?';

    return rollWidth + ' x ' + length + ' variant is missing for this product. Please contact us or choose another product.';
  }

  function accessoryRuleLabel(accessory) {
    if (!accessory) return '';
    if (accessory.key === 'nails') return '1 box per 1,000 sq ft';
    if (accessory.key === 'weed_barrier') return '1 roll per 1,500 sq ft';
    if (accessory.key === 'gopher_wire') return '1 roll per 400 sq ft';
    if (accessory.key === 'seam_tape') return '1 roll per 50 seam ft';

    var coverage = numberValue(accessory.coverageSqft);
    return coverage > 0 ? '1 unit per ' + coverage + ' sq ft' : variantTitle(accessory.variant);
  }

  function firstAvailableVariant(product, variantId) {
    var variants = product && product.variants ? product.variants : [];
    var normalizedId = String(variantId || '').trim();
    var match = normalizedId ? variants.find(function(variant) {
      return String(variant.id) === normalizedId;
    }) : null;

    return match || variants.find(function(variant) {
      return variant.available;
    }) || variants[0] || null;
  }

  function TurfConfigurator(element) {
    this.element = element;
    this.config = JSON.parse(element.querySelector('[data-turf-configurator-json]').textContent);
    this.product = this.config.product || {};
    this.settings = this.config.settings || {};
    this.rollWidth = numberValue(this.settings.rollWidthFt) || TurfCore.DEFAULTS.ROLL_WIDTH_FT;
    this.wastePercent = Math.max(0, numberValue(this.settings.wastePercent));
    this.maxRollLength = integerValue(this.settings.maxRollLengthFt) || TurfCore.DEFAULTS.MAX_ROLL_LENGTH_FT;
    this.checkoutMinimumSqft = TurfCore.DEFAULTS.MIN_CHECKOUT_SQFT;
    this.variants = this.buildRollVariants();
    this.mode = 'sqft';
    this.cuts = [];
    this.cutsManual = false;
    this.cutCounter = 0;
    this.isSubmitting = false;
    this.fields = {
      sqft: element.querySelector('[data-turf-field="sqft"]'),
      length: element.querySelector('[data-turf-field="length"]'),
      width: element.querySelector('[data-turf-field="width"]'),
      cutNotes: element.querySelector('[data-turf-field="cutNotes"]')
    };
    this.message = element.querySelector('[data-turf-message]');
    this.submitButton = element.querySelector('[data-turf-submit]');
    this.cutsElement = element.querySelector('[data-turf-cuts]');
    this.accessoriesElement = element.querySelector('[data-turf-accessories]');
    this.accessoriesSection = element.querySelector('[data-turf-accessories-section]');
    this.outputs = {};

    Array.prototype.forEach.call(element.querySelectorAll('[data-turf-output]'), function(node) {
      this.outputs[node.getAttribute('data-turf-output')] = node;
    }, this);

    this.renderAccessories();
    this.attachListeners();
    this.update();
  }

  TurfConfigurator.prototype.buildRollVariants = function() {
    var rollWidth = this.rollWidth;
    var variants = (this.product.variants || []).map(function(variant) {
      var length = integerValue(variant.rollLength) || [variant.title, variant.option1, variant.option2, variant.option3, variant.sku].reduce(function(found, value) {
        return found || parseRollLength(value, rollWidth);
      }, null);

      return {
        id: variant.id,
        title: variant.title,
        price: variant.price,
        available: variant.available,
        rollLength: length,
        source: variant
      };
    }).filter(function(variant) {
      return variant.rollLength !== null && variant.rollLength > 0;
    });

    return variants.sort(function(a, b) {
      return a.rollLength - b.rollLength;
    });
  };

  TurfConfigurator.prototype.availableRollVariants = function() {
    return this.variants.filter(function(variant) {
      return variant.available && variant.rollLength > 0 && variant.rollLength <= this.maxRollLength;
    }, this);
  };

  TurfConfigurator.prototype.maxAvailableLength = function() {
    var variants = this.availableRollVariants();
    return variants.length ? variants[variants.length - 1].rollLength : this.maxRollLength;
  };

  TurfConfigurator.prototype.newCut = function(length) {
    this.cutCounter += 1;

    return {
      id: 'cut-' + this.cutCounter,
      length: Math.max(1, integerValue(length))
    };
  };

  TurfConfigurator.prototype.attachListeners = function() {
    var parentForm = this.element.closest('form');
    var selectAllButton = this.element.querySelector('[data-turf-action="select-all-accessories"]');

    if (parentForm && parentForm.dataset.turfConfiguratorSubmitGuard !== 'true') {
      parentForm.dataset.turfConfiguratorSubmitGuard = 'true';
      parentForm.addEventListener('submit', function(event) {
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    this.element.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' && event.target && event.target.tagName !== 'TEXTAREA') {
        event.preventDefault();
      }
    });

    if (selectAllButton) {
      selectAllButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        this.toggleAllAccessories();
      }.bind(this));
    }

    this.element.addEventListener('change', function(event) {
      var field = event.target.getAttribute('data-turf-field');

      if (field === 'mode') {
        this.mode = event.target.value;
        this.cutsManual = false;
        this.toggleMode();
        return;
      }

      if (event.target.matches('[data-turf-accessory-check]')) {
        this.update();
      }
    }.bind(this));

    this.element.addEventListener('input', function(event) {
      if (event.target === this.fields.sqft || event.target === this.fields.length || event.target === this.fields.width) {
        this.cutsManual = false;
        this.update();
        return;
      }

      if (event.target.matches('[data-turf-cut-length]')) {
        this.updateCutLength(event.target);
        this.cutsManual = true;
        this.update({ preserveCutFocus: true });
        return;
      }

      if (event.target.matches('[data-turf-accessory-qty]')) {
        event.target.dataset.manual = 'true';
        this.update();
        return;
      }

      if (event.target === this.fields.cutNotes) {
        this.update();
      }
    }.bind(this));

    this.element.addEventListener('click', function(event) {
      var actionTarget = event.target.closest('[data-turf-action]');
      if (!actionTarget || !this.element.contains(actionTarget)) return;

      var action = actionTarget.getAttribute('data-turf-action');
      event.preventDefault();

      if (action === 'increase-sqft' || action === 'decrease-sqft') {
        this.adjustSqft(action === 'increase-sqft' ? 50 : -50);
      } else if (action === 'add-cut') {
        this.addCut();
      } else if (action === 'remove-cut') {
        this.removeCut(actionTarget.getAttribute('data-cut-id'));
      } else if (action === 'decrease-accessory' || action === 'increase-accessory') {
        this.adjustAccessoryQty(actionTarget, action === 'increase-accessory' ? 1 : -1);
      }
    }.bind(this));

    this.submitButton.addEventListener('click', this.addToCart.bind(this));
  };

  TurfConfigurator.prototype.toggleMode = function() {
    Array.prototype.forEach.call(this.element.querySelectorAll('[data-turf-panel]'), function(panel) {
      panel.hidden = panel.getAttribute('data-turf-panel') !== this.mode;
    }, this);

    this.update();
  };

  TurfConfigurator.prototype.adjustSqft = function(delta) {
    var current = integerValue(this.fields.sqft.value);
    var next = current ? current + delta : 500;

    this.fields.sqft.value = String(Math.max(1, next));
    this.cutsManual = false;
    this.update();
  };

  TurfConfigurator.prototype.addCut = function() {
    var state = this.currentState || this.projectState();
    var baseLength = this.cuts.length ? this.cuts[this.cuts.length - 1].length : Math.ceil((state.projectSqft || this.rollWidth) / this.rollWidth);
    this.cuts.push(this.newCut(Math.min(baseLength, this.maxAvailableLength())));
    this.cutsManual = true;
    this.update();
  };

  TurfConfigurator.prototype.removeCut = function(cutId) {
    if (this.cuts.length <= 1) return;
    this.cuts = this.cuts.filter(function(cut) {
      return cut.id !== cutId;
    });
    this.cutsManual = true;
    this.update();
  };

  TurfConfigurator.prototype.updateCutLength = function(input) {
    var cutId = input.getAttribute('data-cut-id');
    var nextLength = Math.max(1, integerValue(input.value));

    this.cuts = this.cuts.map(function(cut) {
      if (cut.id !== cutId) return cut;
      return {
        id: cut.id,
        length: nextLength
      };
    });
  };

  TurfConfigurator.prototype.toggleAllAccessories = function() {
    var rows = Array.prototype.slice.call(this.element.querySelectorAll('[data-turf-accessory]'));
    var shouldCheck = rows.some(function(row) {
      var check = row.querySelector('[data-turf-accessory-check]');
      var input = row.querySelector('[data-turf-accessory-qty]');
      return check && input && integerValue(input.value) > 0 && !check.checked;
    });

    rows.forEach(function(row) {
      var check = row.querySelector('[data-turf-accessory-check]');
      var input = row.querySelector('[data-turf-accessory-qty]');
      if (!check || !input) return;
      check.checked = shouldCheck && integerValue(input.value) > 0;
    });

    this.update();
  };

  TurfConfigurator.prototype.adjustAccessoryQty = function(button, delta) {
    var row = button.closest('[data-turf-accessory]');
    if (!row) return;

    var input = row.querySelector('[data-turf-accessory-qty]');
    input.dataset.manual = 'true';
    input.value = String(Math.max(1, integerValue(input.value) + delta));
    this.update();
  };

  TurfConfigurator.prototype.projectState = function() {
    var sqft = numberValue(this.fields.sqft.value);
    var length = numberValue(this.fields.length.value);
    var width = numberValue(this.fields.width.value);
    var projectSqft = this.mode === 'dimensions' ? length * width : sqft;
    var roundedProjectSqft = Math.ceil(projectSqft);
    var plan = this.cutsManual ? this.manualPlan(roundedProjectSqft) : this.autoPlan(roundedProjectSqft, length, width);
    var resolvedCuts = this.resolveCuts(plan.cuts);
    var getSqft = resolvedCuts.reduce(function(total, cut) {
      return total + cut.coverageSqft;
    }, 0);
    var turfSubtotal = resolvedCuts.reduce(function(total, cut) {
      return total + (cut.variant ? cut.variant.price : 0);
    }, 0);
    var checkoutMinimumSqft = this.checkoutMinimumSqft;

    return {
      mode: this.mode,
      sqft: sqft,
      length: length,
      width: width,
      projectSqft: roundedProjectSqft,
      bufferSqft: Math.max(0, numberValue(plan.bufferSqft)),
      requiredSqft: Math.max(0, numberValue(plan.requiredSqft)),
      requiredLinearFt: Math.max(0, integerValue(plan.requiredLinearFt)),
      cuts: plan.cuts,
      resolvedCuts: resolvedCuts,
      getSqft: getSqft,
      extraSqft: Math.max(0, getSqft - roundedProjectSqft),
      checkoutMinimumSqft: checkoutMinimumSqft,
      minimumNotMet: roundedProjectSqft > 0 && getSqft > 0 && getSqft < checkoutMinimumSqft,
      seamLinearFt: Math.max(0, integerValue(plan.seamLinearFt)),
      turfSubtotal: turfSubtotal,
      planLabel: plan.label,
      isManualPlan: this.cutsManual,
      cutNotes: this.fields.cutNotes.value.trim()
    };
  };

  TurfConfigurator.prototype.autoPlan = function(projectSqft, length, width) {
    if (projectSqft <= 0) {
      return {
        label: 'Enter a project size to build a cut plan.',
        cuts: []
      };
    }

    if (this.mode === 'dimensions' && length > 0 && width > 0) {
      return this.dimensionPlan(length, width);
    }

    return this.squareFootagePlan(projectSqft);
  };

  TurfConfigurator.prototype.squareFootagePlan = function(projectSqft) {
    var plan = TurfCore.calculateTurfCuts(projectSqft, {
      rollWidthFt: this.rollWidth,
      maxRollLengthFt: this.maxAvailableLength(),
      bufferRate: this.wastePercent / 100
    });
    var cuts = plan.cuts.map(function(cut) {
      return this.newCut(cut.length);
    }, this);

    var wasteLabel = this.wastePercent > 0 ? ' with ' + this.wastePercent + '% waste buffer' : '';
    var seamLinearFt = Math.max(0, cuts.length - 1) * this.rollWidth;

    return {
      label: plural(cuts.length, 'cut', 'cuts') + ' from ' + plural(cuts.length, 'roll', 'rolls') + wasteLabel + ' - auto-calculated',
      cuts: cuts,
      seamLinearFt: seamLinearFt,
      bufferSqft: plan.bufferSqft,
      requiredSqft: plan.requiredSqft,
      requiredLinearFt: plan.requiredLinearFt
    };
  };

  TurfConfigurator.prototype.dimensionPlan = function(length, width) {
    var candidates = [
      this.dimensionCandidate(length, width, 'Runs along project length'),
      this.dimensionCandidate(width, length, 'Runs along project width')
    ].filter(Boolean);

    candidates.sort(function(a, b) {
      if (a.getSqft !== b.getSqft) return a.getSqft - b.getSqft;
      if (a.seamLinearFt !== b.seamLinearFt) return a.seamLinearFt - b.seamLinearFt;
      return a.cuts.length - b.cuts.length;
    });

    return candidates[0] || this.squareFootagePlan(Math.ceil(length * width));
  };

  TurfConfigurator.prototype.dimensionCandidate = function(runLength, crossWidth, label) {
    var stripCount = Math.ceil(crossWidth / this.rollWidth);
    var maxLength = this.maxAvailableLength();
    var segmentCount = Math.max(1, Math.ceil(runLength / maxLength));
    var segmentLength = Math.ceil(runLength / segmentCount);
    var cuts = [];
    var longSeamFt = Math.max(0, stripCount - 1) * runLength;
    var buttSeamFt = stripCount * Math.max(0, segmentCount - 1) * this.rollWidth;
    var seamLinearFt = Math.ceil(longSeamFt + buttSeamFt);

    for (var strip = 0; strip < stripCount; strip += 1) {
      for (var segment = 0; segment < segmentCount; segment += 1) {
        cuts.push(this.newCut(segmentLength));
      }
    }

    return {
      label: plural(cuts.length, 'cut', 'cuts') + ' - ' + label + ' - auto-optimized',
      cuts: cuts,
      seamLinearFt: seamLinearFt,
      getSqft: cuts.reduce(function(total, cut) {
        return total + cut.length * this.rollWidth;
      }.bind(this), 0)
    };
  };

  TurfConfigurator.prototype.manualPlan = function(projectSqft) {
    var cuts = this.cuts.length ? this.cuts.slice() : this.squareFootagePlan(projectSqft || this.rollWidth).cuts;

    return {
      label: plural(cuts.length, 'custom cut', 'custom cuts'),
      cuts: cuts,
      seamLinearFt: Math.max(0, cuts.length - 1) * this.rollWidth
    };
  };

  TurfConfigurator.prototype.findRollVariant = function(length) {
    if (!length) return null;

    return TurfCore.findExactVariantForCut({
      variants: this.availableRollVariants()
    }, this.rollWidth, length, {
      rollWidthFt: this.rollWidth,
      maxRollLengthFt: this.maxRollLength
    });
  };

  TurfConfigurator.prototype.resolveCuts = function(cuts) {
    return cuts.map(function(cut, index) {
      var variant = this.findRollVariant(cut.length);
      var actualLength = variant ? variant.rollLength : cut.length;

      return {
        id: cut.id,
        index: index + 1,
        requestedLength: cut.length,
        actualLength: actualLength,
        coverageSqft: actualLength * this.rollWidth,
        variant: variant
      };
    }, this);
  };

  TurfConfigurator.prototype.renderCuts = function(state) {
    var active = document.activeElement;
    var activeCutId = active && active.matches('[data-turf-cut-length]') ? active.getAttribute('data-cut-id') : null;
    var activeSelectionStart = activeCutId ? active.selectionStart : null;
    var activeSelectionEnd = activeCutId ? active.selectionEnd : null;

    this.cuts = state.cuts.slice();

    if (!state.resolvedCuts.length) {
      this.cutsElement.innerHTML = '<div class="turf-configurator__empty">Enter your project size to see the cut list.</div>';
      return;
    }

    this.cutsElement.innerHTML = [
      '<div class="turf-configurator__cuts-head">',
        '<span>#</span>',
        '<span>Dimensions</span>',
        '<span>Area</span>',
        '<span></span>',
      '</div>',
      state.resolvedCuts.map(function(cut) {
        var disabledRemove = state.resolvedCuts.length <= 1 ? ' disabled aria-disabled="true"' : '';
        var areaLabel = cut.coverageSqft + ' sq ft';
        var missingLabel = !cut.variant ? '<small>' + escapeHtml(missingVariantMessage(cut, this.rollWidth)) + '</small>' : '';

        return [
          '<div class="turf-configurator__cut-row" data-turf-cut data-cut-id="' + cut.id + '">',
            '<span class="turf-configurator__cut-index">' + cut.index + '</span>',
            '<label class="turf-configurator__cut-size">',
              '<span>' + this.rollWidth + ' ft x</span>',
              '<input type="text" inputmode="numeric" autocomplete="off" value="' + cut.requestedLength + '" data-cut-id="' + cut.id + '" data-turf-cut-length>',
              '<span>ft</span>',
              missingLabel,
            '</label>',
            '<strong>' + areaLabel + '</strong>',
            '<button type="button" data-turf-action="remove-cut" data-cut-id="' + cut.id + '"' + disabledRemove + '>Remove</button>',
          '</div>'
        ].join('');
      }, this).join('')
    ].join('');

    if (activeCutId) {
      var nextActive = this.cutsElement.querySelector('[data-turf-cut-length][data-cut-id="' + activeCutId + '"]');
      if (nextActive) {
        nextActive.focus();
        if (activeSelectionStart !== null) nextActive.setSelectionRange(activeSelectionStart, activeSelectionEnd);
      }
    }
  };

  TurfConfigurator.prototype.renderAccessories = function() {
    var accessories = (this.config.accessories || []).map(function(accessory) {
      var variant = firstAvailableVariant(accessory.product, accessory.variantId);
      if (!variant || !variant.available) return null;
      accessory.variant = variant;
      return accessory;
    }).filter(Boolean);

    this.accessories = accessories;

    if (!accessories.length) {
      this.accessoriesSection.hidden = true;
      return;
    }

    this.accessoriesSection.hidden = false;
    this.accessoriesElement.innerHTML = accessories.map(function(accessory, index) {
      var id = 'turf-accessory-' + accessory.key + '-' + index;
      var qtyId = id + '-qty';
      var image = accessory.product && accessory.product.image ? '<img src="' + escapeHtml(accessory.product.image) + '" alt="" loading="lazy">' : '<span aria-hidden="true"></span>';
      var coverageLabel = accessoryRuleLabel(accessory);

      return [
        '<div class="turf-configurator__accessory" data-turf-accessory data-key="' + accessory.key + '">',
          '<label class="turf-configurator__accessory-check" for="' + id + '">',
            '<input id="' + id + '" type="checkbox" data-turf-accessory-check>',
            '<span></span>',
          '</label>',
          '<div class="turf-configurator__accessory-image">' + image + '</div>',
          '<div class="turf-configurator__accessory-main">',
            '<strong>' + escapeHtml(accessory.label) + '</strong>',
            '<span>' + escapeHtml(coverageLabel) + '</span>',
          '</div>',
          '<div class="turf-configurator__accessory-qty">',
            '<button type="button" data-turf-action="decrease-accessory" aria-label="Decrease ' + escapeHtml(accessory.label) + '">-</button>',
            '<input id="' + qtyId + '" type="text" inputmode="numeric" autocomplete="off" value="1" data-turf-accessory-qty aria-label="' + escapeHtml(accessory.label) + ' quantity">',
            '<button type="button" data-turf-action="increase-accessory" aria-label="Increase ' + escapeHtml(accessory.label) + '">+</button>',
          '</div>',
          '<strong class="turf-configurator__accessory-price" data-turf-accessory-price>' + money(accessory.variant.price) + '</strong>',
        '</div>'
      ].join('');
    }).join('');
  };

  TurfConfigurator.prototype.selectedAccessories = function() {
    var rows = Array.prototype.slice.call(this.element.querySelectorAll('[data-turf-accessory]'));

    return rows.map(function(row) {
      var key = row.getAttribute('data-key');
      var accessory = this.accessories.find(function(item) {
        return item.key === key;
      });
      var checked = row.querySelector('[data-turf-accessory-check]').checked;
      var quantity = Math.max(0, integerValue(row.querySelector('[data-turf-accessory-qty]').value));

      return checked && accessory && quantity > 0 ? {
        accessory: accessory,
        quantity: quantity
      } : null;
    }, this).filter(Boolean);
  };

  TurfConfigurator.prototype.recommendedAccessoryQuantity = function(accessory, state) {
    if (!accessory || !state || state.projectSqft <= 0) return 0;

    return TurfCore.recommendedSupplyQuantity(accessory, state);
  };

  TurfConfigurator.prototype.autoAccessoryQuantities = function(state) {
    Array.prototype.forEach.call(this.element.querySelectorAll('[data-turf-accessory]'), function(row) {
      var key = row.getAttribute('data-key');
      var accessory = this.accessories.find(function(item) {
        return item.key === key;
      });
      var input = row.querySelector('[data-turf-accessory-qty]');
      var price = row.querySelector('[data-turf-accessory-price]');

      if (!accessory) return;

      if (input.dataset.manual !== 'true') {
        input.value = String(this.recommendedAccessoryQuantity(accessory, state));
      }

      price.textContent = money(accessory.variant.price * Math.max(0, integerValue(input.value)));
    }, this);
  };

  TurfConfigurator.prototype.update = function(options) {
    var state = this.projectState();
    this.autoAccessoryQuantities(state);

    var selectedAccessories = this.selectedAccessories();
    var accessorySubtotal = selectedAccessories.reduce(function(total, item) {
      return total + item.accessory.variant.price * item.quantity;
    }, 0);
    var subtotal = state.turfSubtotal + accessorySubtotal;
    var message = '';
    var messageState = '';
    var missingVariant = state.resolvedCuts.find(function(cut) {
      return !cut.variant;
    });

    if (!options || !options.skipCutRender) {
      this.renderCuts(state);
    }

    if (state.projectSqft <= 0) {
      message = 'Enter a project size to see the recommended cuts.';
    } else if (missingVariant) {
      message = missingVariantMessage(missingVariant, this.rollWidth);
      messageState = 'error';
    } else if (state.minimumNotMet) {
      message = 'You can add this cut to cart, but checkout requires at least ' + state.checkoutMinimumSqft + ' sq ft total across all 15 ft turf roll items.';
    }

    this.outputs.minimumSqft.textContent = state.checkoutMinimumSqft + ' sq ft';
    this.outputs.cutHeadline.textContent = state.projectSqft > 0 ? state.planLabel : 'Enter a project size to build a cut plan.';
    this.outputs.projectSqft.textContent = state.projectSqft ? state.projectSqft + ' sq ft' : '-';
    this.outputs.coversSqft.textContent = state.getSqft ? state.getSqft + ' sq ft' : '-';
    this.outputs.wasteSqft.textContent = state.projectSqft ? state.extraSqft + ' sq ft' : '-';
    this.outputs.suppliesHeadline.textContent = state.projectSqft ? 'Qty auto-calculated for your ' + state.projectSqft + ' sq ft project' : 'Quantities update from your project size.';
    this.outputs.summaryNeed.textContent = state.projectSqft ? state.projectSqft + ' sq ft' : 'Enter size';
    this.outputs.summaryGet.textContent = state.getSqft ? state.getSqft + ' sq ft' : 'Calculated';
    this.outputs.summaryRolls.textContent = state.resolvedCuts.length ? String(state.resolvedCuts.length) : 'Calculated';
    if (this.outputs.summaryRollSize) this.outputs.summaryRollSize.textContent = state.resolvedCuts.length ? rollSummary(state, this.rollWidth) : 'Calculated';
    if (this.outputs.summaryWastePercent) this.outputs.summaryWastePercent.textContent = this.wastePercent > 0 ? this.wastePercent + '%' : 'None';
    this.outputs.summaryTurf.textContent = state.turfSubtotal > 0 ? 'Turf (' + state.getSqft + ' sq ft) ' + money(state.turfSubtotal) : 'Enter project size';
    this.outputs.summaryInstallItems.textContent = money(accessorySubtotal);
    this.outputs.subtotal.textContent = subtotal > 0 ? money(subtotal) : 'Enter size';

    this.currentState = state;
    this.setMessage(message, messageState);
    this.submitButton.disabled = this.isSubmitting || !state.resolvedCuts.length || state.projectSqft <= 0 || messageState === 'error';
  };

  TurfConfigurator.prototype.setMessage = function(message, state) {
    this.message.textContent = message || '';
    if (state) {
      this.message.setAttribute('data-state', state);
    } else {
      this.message.removeAttribute('data-state');
    }
  };

  TurfConfigurator.prototype.addToCart = function() {
    var state = this.currentState;

    if (!state || !state.resolvedCuts.length || this.isSubmitting) return;

    var missingVariant = state.resolvedCuts.find(function(cut) {
      return !cut.variant;
    });

    if (missingVariant) {
      this.setMessage(missingVariantMessage(missingVariant, this.rollWidth), 'error');
      return;
    }

    var selectedAccessories = this.selectedAccessories();
    var items = state.resolvedCuts.map(function(cut) {
      return {
        id: cut.variant.id,
        quantity: 1,
        properties: {
          'Project Sq Ft': String(state.projectSqft),
          'Recommended Roll': this.rollWidth + ' ft x ' + cut.actualLength + ' ft',
          'Waste %': this.wastePercent + '%',
          'Requested Dimensions': requestedDimensions(state),
          'Cut Number': String(cut.index),
          'Cut Size': this.rollWidth + ' ft x ' + cut.actualLength + ' ft',
          'Requested Cut Length': cut.requestedLength + ' ft',
          'Cut Coverage': cut.coverageSqft + ' sq ft',
          'Cut Plan': plural(state.resolvedCuts.length, 'cut', 'cuts'),
          'Extra Coverage': state.extraSqft + ' sq ft',
          'Checkout Minimum': state.checkoutMinimumSqft + ' sq ft',
          'Estimated Seam Length': state.seamLinearFt + ' ft',
          'Cut Notes': state.cutNotes || 'None',
          'Source': 'Turf Configurator'
        }
      };
    }, this).concat(selectedAccessories.map(function(item) {
      return {
        id: item.accessory.variant.id,
        quantity: item.quantity,
        properties: {
          'Recommended For': state.projectSqft + ' sq ft turf project',
          'Recommended Quantity Rule': accessoryRuleLabel(item.accessory),
          'Estimated Seam Length': state.seamLinearFt + ' ft',
          'Source': 'Turf Configurator'
        }
      };
    }));

    this.isSubmitting = true;
    this.submitButton.disabled = true;
    this.submitButton.textContent = 'Adding...';
    this.setMessage('', '');
    document.dispatchEvent(new CustomEvent('theme:loading:start'));

    fetch(cartAddUrl(), {
      body: JSON.stringify({ items: items }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function(response) {
      if (!response.ok) {
        return response.json().then(function(payload) {
          throw new Error(payload.description || payload.message || 'Unable to add this turf package to cart.');
        });
      }

      return response.json();
    }).then(function() {
      this.setMessage('Added to cart.', 'success');

      if (window.theme && window.theme.cartType === 'drawer' && document.querySelector('.mini-cart')) {
        this.element.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: state.resolvedCuts[0].variant.source || state.resolvedCuts[0].variant,
            button: this.submitButton,
            quantity: items.reduce(function(total, item) {
              return total + item.quantity;
            }, 0)
          }
        }));
      } else {
        window.location.href = cartUrl();
      }
    }.bind(this)).catch(function(error) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      this.setMessage(error.message || 'Network error. Please try again.', 'error');
    }.bind(this)).finally(function() {
      this.isSubmitting = false;
      this.submitButton.textContent = 'Add Turf Package to Cart';
      this.update();
    }.bind(this));
  };

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-turf-configurator]'), function(element) {
      if (element.dataset.turfConfiguratorReady === 'true') return;
      element.dataset.turfConfiguratorReady = 'true';
      new TurfConfigurator(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

(function() {
  var bestSellerHandles = {
    'affordable-turf-1-75-88-oz-artificial-grass': true,
    'artificial-grass-affordable-k9-85oz-1-25-fully-permeable': true
  };

  function starSvg(className, half) {
    var fill = half ? 'url(#rating-star-gradient-half)' : 'currentColor';
    return '<svg fill="none" focusable="false" role="presentation" class="icon icon--rating-star ' + className + '" viewBox="0 0 896 832"><path d="M896 320l-313.5-40.781L448 0 313.469 279.219 0 320l230.469 208.875L171 831.938l277-148.812 277.062 148.812L665.5 528.875z" fill-rule="nonzero" fill="' + fill + '"></path></svg>';
  }

  function ratingMarkup(rating, count) {
    var value = parseFloat(rating);
    var decimal = value % 1;
    var rounding = 0;
    var stars = '';

    if (decimal >= 0.3 && decimal <= 0.7) {
      rounding = 0.5;
    } else if (decimal > 0.7) {
      rounding = 1;
    }

    for (var i = 1; i <= 5; i += 1) {
      if (value >= i) {
        stars += starSvg('rating__star rating__star--full', false);
      } else if (rounding === 0.5) {
        stars += starSvg('rating__star rating__star--half', true);
        rounding = false;
      } else if (rounding === 1) {
        stars += starSvg('rating__star rating__star--full', false);
        rounding = false;
      } else {
        stars += starSvg('rating__star rating__star--empty', false);
      }
    }

    return '<div class="rating"><div class="rating__stars" role="img" aria-label="' + rating + ' out of 5 stars">' + stars + '</div><span class="rating__caption">' + rating + ' (' + count + ' reviews)</span></div>';
  }

  function productData() {
    var node = document.querySelector('[data-turf-configurator-json]');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent).product || null;
    } catch (error) {
      return null;
    }
  }

  function run() {
    var header = document.querySelector('.turf-product-configurator__header');
    if (!header || header.querySelector('.turf-product-configurator__rating, .rating')) return;

    var data = productData();
    if (!data || !data.id) return;

    var id = Number(data.id);
    var handle = String(data.handle || '');
    var isBestSeller = Boolean(bestSellerHandles[handle]);
    var rating = isBestSeller ? '4.9' : ['4.6', '4.7', '4.8'][id % 3];
    var count = isBestSeller ? (id % 21) + 159 : (id % 45) + 79;
    var title = header.querySelector('.turf-product-configurator__title');
    var ratingNode = document.createElement('div');

    ratingNode.className = 'turf-product-configurator__rating';
    ratingNode.style.margin = '8px 0 12px';
    ratingNode.innerHTML = ratingMarkup(rating, count);

    if (title && title.parentNode === header) {
      title.insertAdjacentElement('afterend', ratingNode);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
  window.setTimeout(run, 400);
})();
